/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, disable, themeV2 } from '@insticator/insticator-ui';
import { hoverTransition } from '../../../../../utils/styles/general';



/* ++++++++++ --------------- NAV SUB ITEM : STYLES --------------- ++++++++++ */
export default {
	navsubitem: {
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		padding: replacePXinStringWithEM('16px 0'),
		'& .indicator': {
			background: '#fff', // added to overlap the absolute positioned static line to create the appearance of a break
			paddingTop: pxToEm(5), // tweaking this makes the break between the dot and the line larger or smaller
			paddingBottom: pxToEm(5), // tweaking this makes the break between the dot and the line larger or smaller
			marginLeft: pxToEm(22), // must be aligned properly with the "line" styles in navitem
			marginRight: pxToEm(22),
			'& .dot': {
				background: themeV2.color.base.gray.dark,
				borderRadius: '100%',
				width: pxToEm(5),
				height: pxToEm(5),
				extend: hoverTransition()
			}
		},
		'& .text': {
			color: themeV2.color.base.gray.dark,
			// flex: '1',
			marginRight: pxToEm(8),
			fontSize: pxToEm(14),
			extend: hoverTransition()
		},
		'&.isDisabled': {
			'&-true': {
        extend: disable,
        filter: 'none',
        opacity: 1,
        '& .text': { 
          color: themeV2.color.base.disabled,
         },
         '& .indicator .dot': {
          background: themeV2.color.base.disabled
         }
			}
		},
		'&.isActive': {
			'&-true': {
				cursor: 'default',
				'& .indicator .dot': { background: themeV2.color.primary.main },
				'& .text': { color: themeV2.color.primary.main }
			},
			'&-false': {
				'&:hover': {
					// '& .text': { color: `rgba(6, 43, 117, 0.9)` },
					// '& .indicator .dot': { background: `rgba(6, 43, 117, 0.9)` }
					'& .text, .dot': { filter: 'brightness(45%)' }
				}
			}
		}
	}
}; 